/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { InstanceData } from "../../../models/instance-data";
import { Property } from 'app/models/property';

/**
 * Used to break apart an Instance's Data into manageable chucks for
 * the UI to display / alter.
 */
export class PropertyDataUI {

  /** Property the Instance Data is for */
  mProperty: Property;

  /** Instance Data for the Property */
  mData: InstanceData[];

}
